import classnames from "classnames"
import PropTypes from "prop-types"
import React from "react"

const ComparePanel = ({ acceptedPaymentMethods, allowDirectPayment, copy }) => {
  const rows = [
    acceptedPaymentMethods.includes("us_bank_account") && {
      label: copy.compareAch,
      value: copy.noAddedCost,
    },
    {
      label: copy.compareCredit,
      value: copy.surchargeRate || copy.noAddedCost,
      warning: Boolean(copy.surchargeRate),
    },
    { label: copy.compareDebit, value: copy.noAddedCost },
    allowDirectPayment && {
      label: copy.compareCash,
      value: copy.noOnlinePayment,
    },
  ].filter(Boolean)

  return (
    <section className="rounded-lg border border-gray-300 px-4 py-6">
      <h4 className="mb-4 mt-0 font-semibold">{copy.compareTitle}</h4>
      <dl className="m-0 flex flex-col gap-3">
        {rows.map(({ label, value, warning }) => (
          <div key={label} className="flex items-center justify-between gap-4">
            <dt className="text-gray-900">{label}</dt>
            <dd
              className={classnames("m-0 text-right font-semibold", {
                "text-orange-600": warning,
                "text-gray-700": !warning,
              })}
            >
              {value}
            </dd>
          </div>
        ))}
      </dl>
    </section>
  )
}

ComparePanel.propTypes = {
  acceptedPaymentMethods: PropTypes.arrayOf(PropTypes.string).isRequired,
  allowDirectPayment: PropTypes.bool.isRequired,
  copy: PropTypes.shape({
    compareAch: PropTypes.string,
    compareCash: PropTypes.string,
    compareCredit: PropTypes.string,
    compareDebit: PropTypes.string,
    compareTitle: PropTypes.string,
    noAddedCost: PropTypes.string,
    noOnlinePayment: PropTypes.string,
    surchargeRate: PropTypes.string,
  }).isRequired,
}

export default ComparePanel
